/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_common_back_to_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to F1 Fantasy`)
};

const es_common_back_to_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a F1 Fantasy`)
};

const de_common_back_to_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu F1 Fantasy`)
};

const nl_common_back_to_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar F1 Fantasy`)
};

const fr_common_back_to_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à F1 Fantasy`)
};

const it_common_back_to_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna a F1 Fantasy`)
};

const pt_br2_common_back_to_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar para F1 Fantasy`)
};

const pt_common_back_to_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao F1 Fantasy`)
};

const ja_common_back_to_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1ファンタジーに戻る`)
};

const zh_common_back_to_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回F1 Fantasy`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const common_back_to_f1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.common_back_to_f1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("common_back_to_f1", locale)
	if (locale === "en") return en_common_back_to_f1(inputs)
	if (locale === "es") return es_common_back_to_f1(inputs)
	if (locale === "de") return de_common_back_to_f1(inputs)
	if (locale === "nl") return nl_common_back_to_f1(inputs)
	if (locale === "fr") return fr_common_back_to_f1(inputs)
	if (locale === "it") return it_common_back_to_f1(inputs)
	if (locale === "pt-BR") return pt_br2_common_back_to_f1(inputs)
	if (locale === "pt") return pt_common_back_to_f1(inputs)
	if (locale === "ja") return ja_common_back_to_f1(inputs)
	return zh_common_back_to_f1(inputs)
};